import React from "react";
import { Card, Placeholder } from "semantic-ui-react";

export default function SpaceListItemPlaceholder() {
  return (
    <Card>
      <Placeholder>
        <Placeholder.Image rectangular />
      </Placeholder>

      <Card.Content>
        <Placeholder>
          <Placeholder.Header>
            <Placeholder.Line length='very short' />
            <Placeholder.Line length='medium' />
          </Placeholder.Header>
          <Placeholder.Paragraph>
            <Placeholder.Line length='short' />
          </Placeholder.Paragraph>
        </Placeholder>
      </Card.Content>
    </Card>
  );
}
